import { useCallback } from "react"; 
import useClientStore from "../store/clientStore";
import useAuthStore from "../store/authStore";
import { createUpdateFileMappings, getFileMappings } from "../API/panelApis";
import { convertToKeyMapping, convertToMapValue, litigationMapping } from "../utils/fileMappings";

export default function useMappings({ type = "" }) {
    const removeMapping = useClientStore((state) => state.removeMapping);
    const addMapping = useClientStore((state) => state.addMapping);
    const fileMappingsObj = useClientStore((state) => state.mappingsObj);
    const addMappingObj = useClientStore((state) => state.addMappingObj);
    const userData = useAuthStore((state) => state.userData);

    async function updateMappings(matchedHeaderNames) {
        let mappingObj = { ...fileMappingsObj };
        for (const [key, value] of Object.entries(matchedHeaderNames)) {
            if (!!value && !!key) {
                mappingObj[key] = {
                    slug: convertToMapValue(value),
                    column: value,
                };
            }
        }
        const res = await createUpdateFileMappings({ client: userData?.client_id, type, mapping: mappingObj });
        if (!!res) {
            console.log("File Mapping Updated...");
            removeMapping();
        }
    }

    const getMappings = useCallback(async () => {
        // For litigation type, use the predefined mapping instead of API call
        if (type === "litigation") {
            addMappingObj({});
            addMapping(litigationMapping);
            return;
        }
        
        // Add a guard clause to prevent API calls without a client_id
        if (!userData?.client_id) {
            return;
        }
        
        try {
            const res = await getFileMappings({ client: userData.client_id, type });
            const mappingData = res?.data?.mapping || {};
            addMappingObj(mappingData);
            addMapping(convertToKeyMapping(mappingData));
        } catch (error) {
            console.error("Failed to fetch mappings:", error);
        }
    }, [userData?.client_id, type, addMapping, addMappingObj]);

    return { updateMappings, getMappings };
}